<div *ngIf="hasError()" class="alert mb-2">
  <div *ngIf="field!.errors?.required" [appTranslate]="getError('required')"></div>
  <div *ngIf="field!.errors?.minlength" [appTranslate]="getError('minLength')"></div>
  <div *ngIf="field!.errors?.pattern" [appTranslate]="getError('pattern')"></div>
  <div *ngIf="field!.errors?.isValidDate === false" [appTranslate]="getError('invalidDate')"></div>
  <div *ngIf="field!.errors?.mustMatch" [appTranslate]="getError('mustMatch')"></div>
  <div *ngIf="hasInvalidAge()" [appTranslate]="getError('minAge')"></div>
</div>
